import {Inject, InjectionToken, Optional, Pipe, PipeTransform} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { map, Observable, of } from 'rxjs';

@Pipe({
  name: 'dynamicLanguage',
  standalone: true
})
export class DynamicLanguagePipe<T> implements PipeTransform {

  constructor(private _translocoService: TranslocoService, @Optional() @Inject(DynamicLanguageVariant) private _dynamicLanguageVariant:IDynamicLanguageVariant ) {
  }
  transform(key: string, lang: string='', params:T ={} as T): Observable<string> {
    const isCustomLangDefined = (lang && lang != '');
    const lang$ = this._dynamicLanguageVariant && !isCustomLangDefined
      ? this._dynamicLanguageVariant.lang$
      : of(isCustomLangDefined ? lang : this._translocoService.getActiveLang());

    return lang$.pipe(
      map(currentLang => {
        if (!key) {
          return '';
        }
        const usedLang = currentLang ? currentLang : this._translocoService.getActiveLang();
        return this._translocoService.translate(key, params, usedLang);
      })
    );

 
  }

}


export interface IDynamicLanguageVariant{
  lang$:Observable<string>
  setLanguage(lang:string):void
}

export const DynamicLanguageVariant = new InjectionToken<IDynamicLanguageVariant>('DynamicLanguageVariant');
